import React, { useEffect, useState } from 'react';
import { VerifyIcon, DotsIcon } from '../../components/Icons';
import { Button, Dropdown } from 'react-bootstrap';
import CopyUserLink from '../../views/profile/CopyUserLink.js';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useSelector } from 'react-redux';
import Avatar from '../Avatar'
import { selectAuthUser } from '../../reducers/auth/auth.selectors';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RecommendedArtist = ({ artist, MoreMenuBtn }) => {

  const history = useHistory();
  const {t} = useTranslation();
  const user = useSelector(selectAuthUser);
  const url = window.location.href
  + 'u' + '/' + artist.user.id + '/' + artist.user.name.replace(/^\s+|\s+$|\s+(?=\s)/g, "  ");
  const getArtistViews = views => {
    if (views === 1) {
      return `${views} view`;
    }
    if (views > 999) {
      const viewsInK = Math.ceil(views / 1000);
      return `${viewsInK} k views`;
    }

    return `${views} views`;
  };
  const getArtistProfile = id => {
    const Artisturl =  'u' + '/' + id + '/' + artist.user.name.replace(/^\s+|\s+$|\s+(?=\s)/g, "  ");
    history.push(Artisturl)
  };
 



  return (
    <div>


      <div className={'d-flex flex-row align-items-center artist-container'}
        style={{
          backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%),  url('${artist.user.cover}')`,
          backgroundSize: 'cover',
          height: '128px',
          width: '100%',
          borderRadius: '8px',
          position: 'relative'

        }}
      >
        {artist.user && artist.user.subscriptionPrice == null && <span className="free-suggestion">{t('Free')}</span>}
        <div className={'suggested-header-dropdown'} style={{
          position: 'absolute !important',
          right: '26px !important',
          top: '20px',
        }}>
          <Dropdown alignRight={true} className={'post-header-dropdown posts-dropdown-recomended'}>
            <Dropdown.Toggle as={MoreMenuBtn}></Dropdown.Toggle>
            <div className='copy-container-wrapper'>
              <Dropdown.Menu className={'posts-dropdown font-size-12 border-radius-modal'}>
                <Dropdown.Item >
                  <CopyUserLink>
                    <CopyToClipboard text={url}>
                      <p className="burger-link text-light-gray d-flex">{t('Copy Profile Link')}</p>
                    </CopyToClipboard>
                  </CopyUserLink>
                </Dropdown.Item>
              </Dropdown.Menu>
            </div>
          </Dropdown>
        </div>
        <div style={{ position: 'relative' }} onClick={() => getArtistProfile(artist.user.id)}>


          <Avatar user={artist.user && artist.user.name} className="d-flex overflow-hidden  border-radius-modal artist-content-container" image={artist.user && artist.user.avatar} style={{

            backgroundSize: 'cover',
            height: '96px',
            width: '96px',
            border: '3px solid #FFFFFF',
            borderRadius: '50px ',
            fontSize: '30px'

          }} />
          {artist.is_online && <span className="active-artist"></span>}

        </div>
        <div className={'artist-name-container'}  onClick={() => getArtistProfile(artist.user.id)}>

          <p className={'font-size-12 font-weight-normal text-light'}>
            <span>{artist.user.name}</span> 
            {artist.user.verification_status === "verified" && 
          <VerifyIcon className="verified-icon-recomended-header" /> }
          </p>
          {artist.user.nickname && <p className={'suggested-nickname font-size-12 font-weight-normal text-light'}><span>@</span><span>{artist.user.nickname}</span></p>}
        </div>
        <div className='name-background' >

        </div>
      </div>
    </div>
  );
};

export default RecommendedArtist;
